import type { CoreRule } from './types'

/**
 * Minimal validation rules for v1.
 *
 * Design goal: keep validation swappable. A future validation library can feed
 * messages into `errorMessages` while leaving UI components unchanged.
 */
export const required: CoreRule<unknown> = (value) => {
  if (value === null || value === undefined) return 'Required'
  if (typeof value === 'string' && value.trim() === '') return 'Required'
  if (Array.isArray(value) && value.length === 0) return 'Required'
  return true
}

export function minLength(min: number): CoreRule<string> {
  return (value) => (value.length >= min ? true : `Must be at least ${min} characters`)
}

export function maxLength(max: number): CoreRule<string> {
  return (value) => (value.length <= max ? true : `Must be at most ${max} characters`)
}

export const email: CoreRule<string> = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const trimmed = value.trim()
  if (!trimmed) return true
  return emailRegex.test(trimmed) ? true : 'Enter a valid email address'
}
